import LineItemFormTab from '@/Enums/CampaignManagement/LineItemFormTab.enum';
import {
  IDV360TicketsLineItemForm,
  IDuplicateDV360TicketsLineItemForm,
} from '@/Interfaces/DV360Tickets/LineItem.interface';
import AudienceTargetingService from '@/Services/AudienceTargeting.service';
import { LINE_ITEM_DEFAULT_GEO, NEW_ITEM_ID } from '@/constants/campaignManagement';
import DV360TicketsAudienceSection from '@/pages/CampaignManagement/CreateCampaign/DV360TicketsLineItemForm/AudienceSection';
import DV360LineItemFormBasicSection from '@/pages/CampaignManagement/CreateCampaign/DV360TicketsLineItemForm/BasicSection';
import DV360TicketsCreativesSection from '@/pages/CampaignManagement/CreateCampaign/DV360TicketsLineItemForm/Creatives';
import DV360LineItemFormSummarySection from '@/pages/CampaignManagement/CreateCampaign/DV360TicketsLineItemForm/Summary';
import LineItemFormDaypartSection from '@/pages/CampaignManagement/CreateCampaign/LineItemForm/Daypart';
import { ALL_WEEK } from '@/pages/CampaignManagement/CreateCampaign/LineItemForm/Daypart/constants';
import LineItemFormGeoSection from '@/pages/CampaignManagement/CreateCampaign/LineItemForm/GeoSection';
import { FC } from 'react';

export const DV360_LINE_ITEM_TABS_COMPONENTS: Partial<Record<LineItemFormTab, FC<any>>> = {
  [LineItemFormTab.Basic]: DV360LineItemFormBasicSection,
  [LineItemFormTab.Geo]: LineItemFormGeoSection,
  [LineItemFormTab.Audience]: DV360TicketsAudienceSection,
  [LineItemFormTab.Daypart]: LineItemFormDaypartSection,
  [LineItemFormTab.Creatives]: DV360TicketsCreativesSection,
  [LineItemFormTab.Summary]: DV360LineItemFormSummarySection,
};

export const defaultFormData: IDV360TicketsLineItemForm = {
  id: NEW_ITEM_ID,
  name: '',
  budget: null,
  bidCpm: null,
  startDate: null,
  endDate: null,
  altId: '',
  product: null,
  geo: LINE_ITEM_DEFAULT_GEO,
  geoFence: null,
  audiences: AudienceTargetingService.defaultAudienceTargeting,
  daypart: ALL_WEEK,
  creatives: [],
};

export const defaultDuplicationFormData: IDuplicateDV360TicketsLineItemForm = {
  name: '',
  budget: null,
  startDate: null,
  endDate: null,
  product: null,
};
